import {Injector} from "@angular/core"
import {getAllGlftAssignments, deleteDataObjectAssignment, deleteDataObject} from "@app/common/helpers/ar/ar"
import {BackendArGenerationTemplateRevisionFragment} from "@pages/ar-generation/backend-ar-generation.generated"

export const removeCachedArData = async (templateRevision: BackendArGenerationTemplateRevisionFragment, injector: Injector): Promise<void> => {
    /*Delete assignments to avoid unique constraint violations*/
    for (const gltfAssignment of templateRevision.gltfAssignments) await deleteDataObjectAssignment(gltfAssignment.id, injector)

    for (const gltfAssignment of templateRevision.gltfAssignments) {
        /*The difference in web / ar lod produces multiple gltf assignments for the same data object. Only delete the data object
        if there is no gltf assignment left.*/
        const allAssignments = await getAllGlftAssignments(gltfAssignment.dataObject.id, injector)
        if (allAssignments.length !== 0) return

        /* The backend's deleteDataObjectAssignment also deletes a data object, if it has no further assignments.
        After a successful gltf greation job, the data object has two assignments (CachedTemplateGltf and JobTaskData).
        In this case, the JobTaskData assignment remains at this point, the backend did not delete the data object yet.
        If an error happens after gltf upload, there is only one assignment and the data object was already deleted. Without
        try/catch, the following deleteDataObject then fails and the ar model can never be re-generated.*/
        try {
            await deleteDataObject(gltfAssignment.dataObject.id, injector) //related ones (usdzs) are cascade-deleted
        } catch {
            // Intentionally ignored: data object may already be deleted
        }
    }
}
